import { AppBar as MuiAppBar, Toolbar } from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import Typography from '@classify/react-core-components/Typography';

export const styles = /* istanbul ignore next */ ({ spacing, breakpoints }) => ({
  root: {
    flexGrow: 1,
  },
  flex: {
    flexGrow: 1,
  },
  navigationIcon: {
    marginLeft: -12,
    marginRight: 20,
  },
  prominent: {
    minHeight: 128,
    alignItems: 'flex-start',
    paddingTop: spacing(1),
  },
  toolbar: {
    padding: `0 ${spacing(2)}`,
  },
  headline: {
    display: 'flex',
    alignItems: 'center',
    flex: 1,
    paddingBottom: spacing(2),
    marginTop: spacing(1),
  },
  headlineProminent: {
    [breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
  },
  actionItems: {
    alignSelf: 'flex-start',
    marginTop: spacing(1),
  },
});

export const AppBar = ({
  actionItems = [],
  children = null,
  classes = {},
  isProminent = false,
  navigationIcon = null,
  title = '',
  titleProps = {},
  ...otherProps
}) => {
  const leftIcon = navigationIcon ? (
    <div className={classes.navigationIcon}>{navigationIcon}</div>
  ) : null;

  return (
    <div className={classes.root}>
      <MuiAppBar {...otherProps}>
        <Toolbar className={`${classes.toolbar || ''} ${isProminent ? classes.prominent : ''}`}>
          <div className={`${classes.headline} ${isProminent ? classes.headlineProminent : ''}`}>
            <div>
              {leftIcon}
              {typeof title === 'string' ? (
                <Typography className={classes.flex} color="inherit" variant="h2" {...titleProps}>
                  {title}
                </Typography>
              ) : (
                title
              )}
            </div>
          </div>
          <div className={classes.actionItems}>{actionItems}</div>
        </Toolbar>
        {children}
      </MuiAppBar>
    </div>
  );
};

export default withStyles(styles)(AppBar);
